<template>

  <div>

    <h1>Finish your registration</h1>

    <div class="flex signin_social">
      <h2>Please fill the following fields to end your registration and <b>start to play</b></h2>
    </div>
    <div class="or"></div>

    <form>
        <p class="flex">
            <label for="signin_console">
                <span>Your console</span>
                <select name="console" id="signin_console">
                    <option value="ps4">PS4</option>
                    <option value="ps5">PS5</option>
                    <option value="one">Xbox One / One X</option>
                    <option value="series">Xbox Series S / X</option>
                </select>
                <span class="error" for="console"></span>
            </label>
            <label for="signin_id">
                <span>PSN <small>or</small> Gamer Tag</span>
                <input type="text" name="id" id="signin_id" required />
                <span class="error" for="id"></span>
            </label>
        </p>

        <p>
            <label for="signin_sponso">
                <span>Sponsorship</span>
                <input type="text" name="sponso" id="signin_sponso" />
                <span class="error" for="sponso"></span>
            </label>
        </p>
        <p>
            <label for="signin_age" class="checkbox"><input type="checkbox" name="age" id="signin_age" required> I certify that I'm 18 year of age or older.</label>
            <label for="signin_tos" class="checkbox"><input type="checkbox" name="tos" id="signin_tos" required> I've read and agree <a href="#" target="_blank">terms of service</a> & <a href="#" target="_blank">privacy policy</a>.</label>
            <label for="signin_news" class="checkbox"><input type="checkbox" name="news" id="signin_news">Ok pour recevoir des news et offres.</label>
            <span class="error" for="age tos news"></span>
        </p>
        <p id="signin_submit">
          <input type="submit" value="Finish my sign up" class="btn_blue" @click="finish()">
        </p>
    </form>

  </div>


</template>

<script>

export default {
  name: 'FinishRegistration',
  data: function() {
    return {
    }
  },
  // mounted(){

  // },
  methods : {

    async finish() {
      try {

        
        
        console.log('user successfully signed up!');
      } catch (err) {
        console.log('error signing up...', err)
      }
    },

  }
}
</script>
